import { FormTypeEnum, PartnerType, SignupExternalLegalEntity } from './types';

export const API_BASE = '/distribution';

export const DEFAULT_COUNTRY = 225;

export const COMMON_STEP_FIELDS = {
    disabled_fields: [] as string[],
    is_partially_filled: false,
    country: DEFAULT_COUNTRY,
    country_selected: true,
};

export const EMPTY_PERSONAL_DATA = {
    disabled_fields: [] as string[],
    is_partially_filled: false,
    first_name: '',
    last_name: '',
    patronym: '',
    birth_date: '',
    pass_number: '',
    issue_date: '',
    issuer_code: '',
    issued_by: '',
    legal_address: '',
    legal_address_postcode: '',
    snils: '',
    inn: '',
};

export const COMMON_LEGAL_DATA: Omit<
    SignupExternalLegalEntity,
    'next_state' | 'previous_state' | 'legal_form'
> = {
    disabled_fields: [],
    is_partially_filled: false,
    vat_rate: 3,
    business_name: '',
    ogrn_or_inn: '',
    legal_address: '',
    legal_address_postcode: '',
};

export const PARTNER_TYPE_TO_FORM_TYPE: Record<PartnerType, FormTypeEnum> = {
    [PartnerType.SE]: FormTypeEnum.SELF_EMPLOYED,
    [PartnerType.IE]: FormTypeEnum.INDIVIDUAL,
    [PartnerType.LLC]: FormTypeEnum.LEGAL_ENTITY,
};
